





































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import HeadLable from '@/components/HeadLable/index.vue'
import InputAutoComplete from '@/components/InputAutoComplete/index.vue'
import TabChange from './tabChange.vue'
import Empty from '@/components/Empty/index.vue'
import { UserModule } from '../../store/modules/user'
import ImageUpload from '@/components/ImgUpload/index.vue'

import {
  getOrderDetailPage,
  queryOrderDetailById,
  passAudit,
  orderPrint,
  getOrderListBy,
  deleteOrder,
  queryLevel,
  addOrder,
  uploadFile,
  queryResvDetailById,
  updateOrder,
  getCompanyByCompanyName,
  getDataByIdCard,
  getDataByCert,
  queryResvDetailByCertificateNumber,
  updateOrder2,
  queryResvDetail
} from '@/api/order'
import axios from 'axios'

@Component({
  components: {
    ImageUpload,
    HeadLable,
    InputAutoComplete,
    TabChange,
    Empty,
  },
})
export default class extends Vue {
  private defaultActivity: any = 0
  private orderStatics = {}
  private dialogOrderStatus = 0
  private row = {}
  private isAutoNext = true
  private isTableOperateBtn = true
  private currentPageIndex = 0 //记录查看详情数据的index
  private orderId = '' //订单号
  private phone = '' //搜索条件的手机号
  private input = '' //搜索条件的订单号
  private zjh = '' //搜索条件的证件号
  private peTime = '' //体检时间
  private isWxorder = 0 //是否为线上预约
  private valueTime = []
  private loading = false //加载弹窗
  private visible = false //删除弹窗
  private dialogVisible = false //详情弹窗
  private dialogVisible2 = false //详情弹窗
  private editDialogVisible = false //审核不通过原因弹窗
  private cancelDialogVisible = false //取消，拒单弹窗
  private cancelDialogTitle = '' //取消，拒绝弹窗标题
  private cancelReason = ''
  private remark = '' //自定义原因
  private counts: number = 0
  private page: number = 1
  private pageSize: number = 10
  private tableData = []
  private diaForm = []
  private id = ''
  private dialogImageUrl = ''
	private status = 0
  private isSearch: boolean = false
  private orderStatus = 0 //列表字段展示所需订单状态,用于分页请求数据
  private level = 4
  private username : string= UserModule.username
  private currentRotation = 0 // 记录当前图片旋转角度
  private dialogCurrentRotation = 0 // 记录对话框中图片旋转角度
  private rotationAngle = 0
  private showNotification: boolean
  private notificationTitle: string
  private notificationText: string
  private orderList = [
    // {
    //   label: '全部预约',
    //   value: 0,
    // },
    {
      label: '待审核',
      value: 1,
    },
    {
      label: '审核通过',
      value: 2,
    },
    {
      label: '审核未通过',
      value: 3,
    },
  ]
  // 新增：弹窗宽度和高度变量
  private dialogWidth = 0
  private dialogHeight = 0
  private timer: any = null




  getDisplayCertificateType(type: number): string {
    switch (type) {
      case 1: return '居民身份证';
      case 19: return '母亲身份证';
      case 2: return '居民户口本';
      case 3: return '护照';
      case 4: return '军官证';
      case 5: return '驾驶证';
      case 6: return '港澳居民来往内地通行证';
      case 7: return '台湾居民来往内地通行证';
      case 98: return '中国人民武装警察身份证件';
      case 99: return '其他法定有效证件';
      default: return '未知证件类型'; // 如果没有匹配到任何已知类型，则返回这个
    }
  }

  getDisplayCompanyQualificationType(type) {
    const qualifications = {
      '1': '营业执照',
      '2': '统一社会信用代码证书',
      '3': '卫生许可证',
      '4': '食品安全许可证',
      '5': '食品经营许可证',
      '6': '其他法定有效证件'
    };
    return qualifications[type] || '未知证件类型';
  }

  getDisplayJobType(type) {
    const qualifications = {
      '1': '食品',
      '2': '乳制品',
      '3': '医药',
      '4': '美容',
      '5': '服务',
      '6': '饮用水',
      '7': '消毒产品生产',
      '99': '其他',
    };
    return qualifications[type] || '未知证件类型';
  }


  created() {
    this.getLevel()
    this.init(Number(this.$route.query.status) || 0)
  }

  mounted() {
    //如果有值说明是消息通知点击进来的
    if (
      this.$route.query.orderId &&
      this.$route.query.orderId !== 'undefined'
    ) {
      this.goDetail(this.$route.query.orderId, 2)
    }
    if (this.$route.query.status) {
      this.defaultActivity = this.$route.query.status
    }
    // 启动自动刷新（每5分钟）
    this.timer = setInterval(() => {
      queryResvDetail().then(res => {
        if (res.data.code === 1 && res.data.data.status === 1) {
          this.showNotification = true;
          this.notificationTitle = '预约管理尚未审核';
        }
      });
    }, 300000); // 5000ms = 5秒

    // console.log(this.$route.query, 'this.$route')
  }

  initFun(orderStatus) {
    this.page = 1
    this.init(orderStatus)
  }

  change(activeIndex) {
    if (activeIndex === this.orderStatus) return
    this.init(activeIndex)
    this.input = ''
    this.phone = ''
    this.zjh = ''
    this.valueTime = []
    this.dialogOrderStatus = 0
    this.$router.push('/order')
    console.log(activeIndex, '接收到了子组件的index')
  }
  //权限获取
  getLevel(){
   const username = UserModule.username

    queryLevel(username)
      .then((res)=>{
        if (res.data.code === 1) {
          this.level=res.data.data
          console.log("lecel:"+this.level)
        } else {
          this.$message.error(res.data.msg)
        }
      })
      .catch((err) => {
        this.$message.error('请求出错了：' + err.message)
      })
  }
  // 获取待处理，待派送，派送中数量
  getOrderListBy3Status() {
    getOrderListBy({})
      .then((res) => {
        if (res.data.code === 1) {
          this.orderStatics = res.data.data
        } else {
          this.$message.error(res.data.msg)
        }
      })
      .catch((err) => {
        this.$message.error('请求出错了：' + err.message)
      })
  }

  init(activeIndex: number = 0, isSearch?) {
    this.isSearch = isSearch
    // 如果status发生变化，则重置page为1，否则保持原值
    const page = (this.orderStatus !== activeIndex) ? 1 : this.page;
    const params = {
      page: page,
      pageSize: this.pageSize,
      username: this.input || undefined,
      phoneNum: this.phone || undefined,
      certificateNumber: this.zjh || undefined,
      peTime: this.peTime || undefined,
      isWxorder:this.isWxorder || undefined,
      beginTime:
        this.valueTime && this.valueTime.length > 0
          ? this.valueTime[0]
          : undefined,
      endTime:
        this.valueTime && this.valueTime.length > 0
          ? this.valueTime[1]
          : undefined,
      status: activeIndex || undefined,
    }
    console.log(params)
    getOrderDetailPage({ ...params })
      .then((res) => {
        if (res.data.code === 1) {
          this.tableData = res.data.data.records
          this.orderStatus = activeIndex
          this.counts = Number(res.data.data.total)
          this.getOrderListBy3Status()
          if (
            this.dialogOrderStatus === 2 &&
            this.orderStatus === 2 &&
            this.isAutoNext &&
            !this.isTableOperateBtn &&
            res.data.data.records.length > 1
          ) {
            const row = res.data.data.records[0]
            this.goDetail(row.id, row.status, row)
          } else {
            return null
          }
        } else {
          this.$message.error(res.data.msg)
        }
      })
      .catch((err) => {
        this.$message.error('请求出错了：' + err.message)
      })
  }

  showImage(url) {
    this.dialogImageUrl = url;
    this.dialogVisible2 = true;
    // 确保查看原图时应用当前旋转角度
    this.dialogCurrentRotation = this.currentRotation;
    const dialogPhoto = this.$refs.dialogPhoto;
    if (dialogPhoto) {
      dialogPhoto.style.transform = `rotate(${this.dialogCurrentRotation}deg)`;
      this.updateDialogSize(dialogPhoto);
    }
  }
  rotatePhoto(degree) {
    const photo = this.$refs.photo;
    const dialogPhoto = this.$refs.dialogPhoto;
    if (photo) {
      // 累加旋转角度
      this.currentRotation += degree;
      photo.style.transform = `rotate(${this.currentRotation}deg)`;
    }
    if (dialogPhoto) {
      // 累加对话框中图片的旋转角度
      this.dialogCurrentRotation += degree;
      dialogPhoto.style.transform = `rotate(${this.dialogCurrentRotation}deg)`;
      // 重新计算弹窗大小
      this.updateDialogSize(dialogPhoto);
    }
  }

  onImageLoad() {
    const img = this.$refs.dialogPhoto;
    // 为弹窗添加一定的内边距
    const padding = 20;
    this.dialogWidth = img.naturalWidth + padding;
    this.dialogHeight = img.naturalHeight + padding;
  }

  updateDialogSize(img) {
    const padding = 20;
    // 旋转90度或270度时交换宽高
    if (Math.abs(this.dialogCurrentRotation) % 180 !== 0) {
      this.dialogWidth = img.naturalHeight + padding;
      this.dialogHeight = img.naturalWidth + padding;
    } else {
      this.dialogWidth = img.naturalWidth + padding;
      this.dialogHeight = img.naturalHeight + padding;
    }
  }
//预约状态
  getOrderType(row: any) {
    if (row.status === 1) {
      return '待审核'
    } else if (row.status === 2) {
      return '审核通过'
    } else if (row.status === 3) {
      return '审核未通过'
    }
  }
  formatDate(row, column, cellValue, index) {
    //显示年月日
    if (!cellValue) return '';
    // 直接从字符串中提取日期部分
    const date = cellValue.split('T')[0];
    return date; // 直接返回日期部分

    //显示时包括时、分
    // const date = new Date(cellValue);
    // // 检查date对象是否有效
    // if (isNaN(date.getTime())) return cellValue; // 如果转换失败，返回原始值
    // const year = date.getFullYear();
    // const month = (date.getMonth() + 1).toString().padStart(2, '0');
    // const day = date.getDate().toString().padStart(2, '0');
    // const hours = date.getHours().toString().padStart(2, '0');
    // const minutes = date.getMinutes().toString().padStart(2, '0');
    // return `${year}-${month}-${day} ${hours}:${minutes}`;
  }


  // 查看详情
  async goDetail(id: any, status: number, row?: any) {
    this.diaForm = []
    this.dialogVisible = true
    this.dialogOrderStatus = status
    this.orderId = id
    console.log("id是"+id)
    const { data } = await queryOrderDetailById({ orderId: id })
    this.diaForm = data.data
    this.row = row || { id: this.$route.query.orderId, status: status }
    if (this.$route.query.orderId) {
      this.$router.push('/order')
    }
  }

  async showWord(row: any) {
    const orderId = row.id;
    console.log("打印体检单是"+this.orderId)
    // 调用orderPrint函数并处理返回的Promise
      try {
        const data = await orderPrint(orderId); // 直接等待orderPrint的结果
        // 假设res是包含PDF文档流数据的ArrayBuffer或其他可转换为Blob的格式
        const blob = new Blob([data], { type: 'application/pdf' });

        // 创建一个iframe用于打印
        const iframe = document.createElement('iframe');
        (iframe.style as any).frameborder = '0'; // 注意这里应该是'0'而不是'no'
        iframe.style.display = 'none';
        iframe.setAttribute('id', 'printPdf');
        iframe.setAttribute('name', 'printPdf');

        // 将Blob的URL设置为iframe的源
        iframe.src = window.URL.createObjectURL(blob);

        // 将iframe添加到文档中
        document.body.appendChild(iframe);
        // 监听iframe加载完成
        iframe.onload = () => {
            try {
                const ordonnance = iframe.contentWindow;
                if (ordonnance && ordonnance.document) {
                    ordonnance.document.execCommand('print', false, null);
                }
                // 清理：如果不需要显示PDF，这里不需要更改display属性
                // document.body.removeChild(iframe);
                // window.URL.revokeObjectURL(iframe.src);
            } catch (error) {
                console.error('Failed to print PDF:', error);
                // 显示错误或进行其他处理
            }
        };

        // document.body.appendChild(iframe);
        //
        // // 可选：添加一个按钮来控制iframe的显示
        // const showPdfButton = document.createElement('button');
        // showPdfButton.textContent = '显示PDF';
        // showPdfButton.onclick = () => {
        //     iframe.style.display = iframe.style.display === 'none' ? 'block' : 'none';
        // };
        // document.body.appendChild(showPdfButton);

    } catch (error) {
        console.error('请求失败:', error);
    }  }
  // 跳转添加预约信息
  private MessageHandle(st : string, username : string) {
			if (st === 'add') {
				this.$router.push({ path: '/orderDetails/add' })
			}
      else {
        //修改预约信息
				this.$router.push({ path: '/orderDetails/add', query: { id: st } })
			}
		}
  //删除预约信息
    private DeleteHandle(type : string, id : string) {
        this.visible = true
        console.log("00000000000"+type, id)
      const confirmResult = confirm('确定要删除吗？');
      if (confirmResult) {
        deleteOrder(id).then(res => {
          if(res.data.code === 1) {
            this.$message.success("删除成功")
            this.init(Number(this.$route.query.status) || 0)
          } else {
            this.$message.error(res.data.msg)
          }
        })
      } else {
        // 用户点击了取消
        console.log('用户取消删除');
      }




    }


  passAudit(row: any) {
			this.orderId = row.id
      this.dialogOrderStatus = row.status
      passAudit({ id: this.orderId ,status: 2,phoneNum: this.diaForm.phoneNum})
        .then((res) => {
          if (res.data.code === 1) {
            this.$message.success('操作成功')
            this.orderId = ''
            // this.dialogOrderStatus = 0
            this.dialogVisible = false
            this.init(this.orderStatus)
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch((err) => {
          this.$message.error('请求出错了：' + err.message)
        })
    this.$router.push('/order')

  }
  noPassAudit(row: any) {
			this.orderId = row.id
      this.dialogOrderStatus = row.status

      passAudit({ id: this.orderId ,status: 3 ,reason: this.diaForm.reason,phoneNum: this.diaForm.phoneNum})
        .then((res) => {
          if (res.data.code === 1) {
            this.$message.success('操作成功')
            // this.editDialogVisible = true;
            this.orderId = ''
            this.dialogVisible = false
            this.init(this.orderStatus)
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch((err) => {
          this.$message.error('请求出错了：' + err.message)
        })
      this.$router.push('/order')
      }

  handleClose() {
    this.dialogVisible = false
  }

  handleClose2() {
    this.editDialogVisible = false
  }

  // 保存修改方法
  private saveEditedData(row:any){
    this.editForm.id = row.id
    console.log(this.editForm.id)


    // 假设这里调用 API 来更新数据库数据
    updateOrder2(this.editForm)
      .then((res) => {
        if (res.data.code === 1) {
          this.$message.success('审核不通过原因已上传');
          console.log(res.data)
          this.editDialogVisible = false;
        } else {
          this.$message.error(res.data.msg);
        }
      })
      .catch((err) => {
        this.$message.error('请求出错了：' + err.message);
      });
  };
  private handleSizeChange(val: any) {
    this.pageSize = val
    this.init(this.orderStatus)
  }

  private handleCurrentChange(val: any) {
    this.page = val
    this.init(this.orderStatus)
  }

}
